// extracted by mini-css-extract-plugin
export default {"productCarousel":"q0-z"};